/**
 * @author Andres Solarte
 * @file index.js
 * @description Patients Records Container
 */

// Dependencies
import React from 'react';
// import PropTypes from 'prop-types';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Patients Container.
 * @return { Node } React Patients container.
 */
const PatientsRecordsContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name Patients.propTypes
 * @type { Object }
 */
PatientsRecordsContainer.propTypes = {};

/**
 * Default props
 */
PatientsRecordsContainer.defaultProps = {};

export default PatientsRecordsContainer;
